import { usePatientIntrospectionQuery } from '@common/cache';
import { useEffect } from 'react';
import { useReportStore } from '@store';
import { Report } from './Report.tsx';

export const PatientsReport = () => {
  const { setIntrospection } = useReportStore();
  const { data } = usePatientIntrospectionQuery();

  useEffect(() => {
    if (data) {
      setIntrospection(data);
    }
  }, [data]);

  return <Report />;
};
